import React from "react";
import { Input } from "antd";
import { FormItem } from "Components/form";
import { Controller } from "react-hook-form";

export default function EditableCell({
  editing,
  dataIndex,
  title,
  inputNode,
  record,
  form,
  index,
  children,
  ...restProps
}) {
  if (!inputNode) inputNode = <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <FormItem required={true}>
          <Controller
            defaultValue={
              record[dataIndex] ||
              (Array.isArray(dataIndex)
                ? dataIndex.reduce((prev, curr) => prev && prev[curr], record)
                : "")
            }
            control={form.control}
            record={record}
            name={Array.isArray(dataIndex) ? dataIndex.join(".") : dataIndex}
            as={inputNode}
          />
        </FormItem>
      ) : (
        children
      )}
    </td>
  );
}
